import {createStore} from "redux"
import {combinedReducer} from "./app/reducers"

// Create the application state store
export default createStore(
    combinedReducer,
    // For debugging only
    (window as any).__REDUX_DEVTOOLS_EXTENSION__ && (window as any).__REDUX_DEVTOOLS_EXTENSION__()
)
